<template>
  <div v-if="confirm" class="q-pa-md q-gutter-sm">
    <q-dialog v-model="confirm" persistent transition-show="scale" transition-hide="scale">
      <q-card style="width: 300px">
        <div class="alert-box">
          <div class="alert-title">ALERT!!</div>
          <div class="alert-content">
            <div class="alert-text" style="text-align:center">
              Are you sure to delete
              <span class="bold">{{selectedLocation.name}}</span>
            </div>
            <div class="alert-actions">
              <q-btn flat @click="reset">CANCEL</q-btn>
              <q-btn flat :loading="loading" label="OK" @click="remove">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "../axios/index";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    reset() {
      this.selectedVehicle = {};
      this.confirm = false;
    },
    async remove() {
      try {
        this.loading = true;
        await axios.delete(`location/${this.selectedLocation.id}`);
        this.$store.commit("location/REMOVE_LOCATION", this.selectedLocation);
        this.$store.commit("vehicle/REM_LOCATION_TO_SELECTED_LOCATION",this.selectedLocation.id)
        this.$store.commit("profit/REM_LOCATION_TO_SELECTED_LOCATION",this.selectedLocation.id)
        this.selectedLocation = {};
        this.confirm = false;
        this.$q.notify({
          message: "Location deleted.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "positive"
        });
      } catch (error) {
        this.$q.notify({
          message: "We can not delete location.Something wrong.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "negative"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    confirm: {
      get() {
        return this.$store.state.location.confirm;
      },
      set(val) {
        this.$store.commit("location/SET_CONFIRM", val);
      }
    },
    selectedLocation: {
      get() {
        return this.$store.state.location.selectedLocation;
      },
      set(val) {
        this.$store.commit("location/SELECTED_LOCATION", val);
      }
    }
  }
};
</script>